import { render } from "./CookiesBanner.vue?vue&type=template&id=24c0d20b&scoped=true"
import script from "./CookiesBanner.vue?vue&type=script&lang=js"
export * from "./CookiesBanner.vue?vue&type=script&lang=js"

import "./CookiesBanner.vue?vue&type=style&index=0&id=24c0d20b&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c0d20b"]])

export default __exports__